export const isImageCached = (src: string) => {
    const image = new Image();
    image.src = src;
    const isComplete = image.complete;
    image.src = '';
    return isComplete;
};
